/* unplugin-vue-components disabled */import { render } from "./AuthorIconGroup.vue?vue&type=template&id=5d059ebc&scoped=true&ts=true"
import script from "./AuthorIconGroup.vue?vue&type=script&lang=ts"
export * from "./AuthorIconGroup.vue?vue&type=script&lang=ts"

import "./AuthorIconGroup.vue?vue&type=style&index=0&id=5d059ebc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d059ebc"]])

export default __exports__